import * as React from 'react';
import {setLoading} from "../redux/loading/actions";
import {useParams} from "react-router-dom";
import {useDispatch} from "react-redux";

const FactorOrder = () => {
    let { id } = useParams();
    const dispatch = useDispatch();

    React.useEffect(() => {
        handlerDownload(id)
    }, [id])

    const handlerDownload = async (id) => {
        dispatch(setLoading(true))
        const pdfUrl = `https://postex.ir/api/order/getpdfinvoice/${id}`; // Replace with the actual PDF URL
        const myHeaders = new Headers();
        myHeaders.append("token", localStorage.getItem('token'));

        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(pdfUrl, requestOptions)
            .then(response => response.blob())
            .then(blob => {
                dispatch(setLoading(false))
                // const link = document.createElement('a');
                // link.href = window.URL.createObjectURL(blob);
                // link.download = `${+new Date()}.pdf`;
                // link.click();
                const pdfWindow = window.open();
                const fileURL = URL.createObjectURL(blob);
                if (pdfWindow) {
                    pdfWindow.location.href = fileURL;
                }
            })
            .catch(error => {
                console.log('error', error)
                dispatch(setLoading(false))
            });
    }

}

export default FactorOrder;